export default "__VITE_ASSET__BuAyYkme__"